import { Colorways } from 'types/constants';
import { getColorwayName } from 'utils/formatters';

export enum ThemeColors {
  Default = '#FFFFFF',
  Dark = '#052316',
}

/**
 * Maps Colorways to their corresponding theme-color meta tag values.
 *
 * The theme-color meta tag sets the browser UI color on mobile devices (when supported)
 */
export function getThemeColorFromColorway(colorway?: Colorways): string {
  if (!colorway) {
    return ThemeColors.Default;
  }

  const colorwayName = getColorwayName(colorway);

  switch (colorwayName) {
    case Colorways.Inverse:
    case Colorways.DarkGreenGradient:
    case Colorways.DarkGreenGradientLeftToRight:
    case Colorways.DarkGreenAnimation:
    case Colorways.Reserve:
      return ThemeColors.Dark;
    default:
      return ThemeColors.Default;
  }
}
